<template>
  <HeaderBase>
    <div class="flex items-center shrink header-title w-1/5">
      <span class="arrow arrow-r arrow-primary"></span>
      <b>Коммуникации</b>
    </div>
    <div class="shrink flex-container flex-dir-row align-center"></div>
  </HeaderBase>
</template>

<script>
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
  },
};
</script>
